module.exports = __webpack_public_path__ + "static/media/1.ec0eb782.JPG";